// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "billing/v1/billing.proto" (package "billing.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Billing proto is defined privately within app, separate from public API,
// because it represents Viam-specific billing implementation and integration with Stripe
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../google/protobuf/timestamp";
import { PaymentMethodUSBankAccount } from "../../app/v1/billing";
import { PaymentMethodCard } from "../../app/v1/billing";
import { PaymentMethodType } from "../../app/v1/billing";
/**
 * @generated from protobuf message billing.v1.Address
 */
export interface Address {
    /**
     * @generated from protobuf field: string line1 = 1;
     */
    line1: string;
    /**
     * @generated from protobuf field: string line2 = 2;
     */
    line2: string;
    /**
     * @generated from protobuf field: string city = 3;
     */
    city: string;
    /**
     * @generated from protobuf field: string state = 4;
     */
    state: string;
    /**
     * @generated from protobuf field: string postal_code = 5;
     */
    postalCode: string;
    /**
     * @generated from protobuf field: string country = 6;
     */
    country: string;
}
/**
 * @generated from protobuf message billing.v1.FinalizeAmountDueRequest
 */
export interface FinalizeAmountDueRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: billing.v1.Address address = 2;
     */
    address?: Address;
}
/**
 * @generated from protobuf message billing.v1.FinalizeAmountDueResponse
 */
export interface FinalizeAmountDueResponse {
    /**
     * @generated from protobuf field: double subtotal = 1;
     */
    subtotal: number;
    /**
     * @generated from protobuf field: double tax = 2;
     */
    tax: number;
    /**
     * @generated from protobuf field: double total = 3;
     */
    total: number;
}
/**
 * @generated from protobuf message billing.v1.CreateStripeSetupIntentRequest
 */
export interface CreateStripeSetupIntentRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message billing.v1.CreateStripeSetupIntentResponse
 */
export interface CreateStripeSetupIntentResponse {
    /**
     * @generated from protobuf field: string client_secret = 1;
     */
    clientSecret: string;
}
/**
 * @generated from protobuf message billing.v1.CreateStripePaymentIntentRequest
 */
export interface CreateStripePaymentIntentRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message billing.v1.CreateStripePaymentIntentResponse
 */
export interface CreateStripePaymentIntentResponse {
    /**
     * @generated from protobuf field: string client_secret = 1;
     */
    clientSecret: string;
}
/**
 * @generated from protobuf message billing.v1.RemoveOrganizationBillingInfoRequest
 */
export interface RemoveOrganizationBillingInfoRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message billing.v1.RemoveOrganizationBillingInfoResponse
 */
export interface RemoveOrganizationBillingInfoResponse {
}
/**
 * @generated from protobuf message billing.v1.ReplaceFragmentRequest
 */
export interface ReplaceFragmentRequest {
    /**
     * @generated from protobuf field: string machine_id = 1;
     */
    machineId: string;
    /**
     * @generated from protobuf field: string fragment_to_delete = 2;
     */
    fragmentToDelete: string;
    /**
     * @generated from protobuf field: string fragment_to_add = 3;
     */
    fragmentToAdd: string;
}
/**
 * @generated from protobuf message billing.v1.ReplaceFragmentResponse
 */
export interface ReplaceFragmentResponse {
}
/**
 * @generated from protobuf message billing.v1.GetCustomBillingMetadataRequest
 */
export interface GetCustomBillingMetadataRequest {
    /**
     * @generated from protobuf field: string namespace = 1;
     */
    namespace: string;
}
/**
 * @generated from protobuf message billing.v1.GetCustomBillingMetadataResponse
 */
export interface GetCustomBillingMetadataResponse {
    /**
     * @generated from protobuf field: optional billing.v1.CustomBillingMetadata metadata = 1;
     */
    metadata?: CustomBillingMetadata;
}
/**
 * @generated from protobuf message billing.v1.MachineWithFragment
 */
export interface MachineWithFragment {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string location_name = 3;
     */
    locationName: string;
    /**
     * @generated from protobuf field: string billing_tier_name = 4;
     */
    billingTierName: string;
}
/**
 * @generated from protobuf message billing.v1.GetMachinesWithBillableFragmentsRequest
 */
export interface GetMachinesWithBillableFragmentsRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: repeated string fragment_ids = 2;
     */
    fragmentIds: string[];
}
/**
 * @generated from protobuf message billing.v1.GetMachinesWithBillableFragmentsResponse
 */
export interface GetMachinesWithBillableFragmentsResponse {
    /**
     * @generated from protobuf field: repeated billing.v1.MachineWithFragment machines = 1;
     */
    machines: MachineWithFragment[];
}
/**
 * @generated from protobuf message billing.v1.CustomBillingMetadata
 */
export interface CustomBillingMetadata {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string email = 2;
     */
    email: string;
    /**
     * buf:lint:ignore FIELD_LOWER_SNAKE_CASE
     *
     * @generated from protobuf field: string orgID = 3;
     */
    orgID: string;
    /**
     * buf:lint:ignore FIELD_LOWER_SNAKE_CASE
     *
     * @generated from protobuf field: string baseURL = 4;
     */
    baseURL: string;
    /**
     * @generated from protobuf field: string logo = 5;
     */
    logo: string;
    /**
     * buf:lint:ignore FIELD_LOWER_SNAKE_CASE
     *
     * @generated from protobuf field: string secondaryLogo = 6;
     */
    secondaryLogo: string;
    /**
     * buf:lint:ignore FIELD_LOWER_SNAKE_CASE
     *
     * @generated from protobuf field: repeated string fragmentPlanIds = 7;
     */
    fragmentPlanIds: string[];
}
/**
 * @generated from protobuf message billing.v1.GetOrgBillingInfoRequest
 */
export interface GetOrgBillingInfoRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message billing.v1.PaymentMethod
 */
export interface PaymentMethod {
    /**
     * @generated from protobuf field: viam.app.v1.PaymentMethodType type = 1;
     */
    type: PaymentMethodType;
    /**
     * @generated from protobuf field: optional viam.app.v1.PaymentMethodCard card = 2;
     */
    card?: PaymentMethodCard;
    /**
     * @generated from protobuf field: billing.v1.PaymentMethodAttachmentStatus method_attachment_status = 4;
     */
    methodAttachmentStatus: PaymentMethodAttachmentStatus;
    /**
     * @generated from protobuf field: optional viam.app.v1.PaymentMethodUSBankAccount us_bank_account = 5;
     */
    usBankAccount?: PaymentMethodUSBankAccount;
}
/**
 * @generated from protobuf message billing.v1.GetOrgBillingInfoResponse
 */
export interface GetOrgBillingInfoResponse {
    /**
     * @generated from protobuf field: string billing_email = 1;
     */
    billingEmail: string;
    /**
     * @generated from protobuf field: optional string billing_tier = 2;
     */
    billingTier?: string;
    /**
     * @generated from protobuf field: optional billing.v1.PaymentMethod method = 3;
     */
    method?: PaymentMethod;
}
/**
 * @generated from protobuf message billing.v1.SetMonthlyBillingAlertThresholdRequest
 */
export interface SetMonthlyBillingAlertThresholdRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: double threshold = 2;
     */
    threshold: number;
}
/**
 * @generated from protobuf message billing.v1.SetMonthlyBillingAlertThresholdResponse
 */
export interface SetMonthlyBillingAlertThresholdResponse {
}
/**
 * @generated from protobuf message billing.v1.DeleteMonthlyBillingAlertThresholdRequest
 */
export interface DeleteMonthlyBillingAlertThresholdRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message billing.v1.DeleteMonthlyBillingAlertThresholdResponse
 */
export interface DeleteMonthlyBillingAlertThresholdResponse {
}
/**
 * @generated from protobuf message billing.v1.GetMonthlyBillingAlertThresholdRequest
 */
export interface GetMonthlyBillingAlertThresholdRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message billing.v1.GetMonthlyBillingAlertThresholdResponse
 */
export interface GetMonthlyBillingAlertThresholdResponse {
    /**
     * @generated from protobuf field: optional double threshold = 1;
     */
    threshold?: number;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp last_notified = 2;
     */
    lastNotified?: Timestamp;
}
/**
 * @generated from protobuf message billing.v1.GetRegistryItemServicePeriodRequest
 */
export interface GetRegistryItemServicePeriodRequest {
    /**
     * @generated from protobuf field: string registry_item_id = 1;
     */
    registryItemId: string;
    /**
     * @generated from protobuf field: string robot_id = 2;
     */
    robotId: string;
}
/**
 * @generated from protobuf message billing.v1.GetRegistryItemServicePeriodResponse
 */
export interface GetRegistryItemServicePeriodResponse {
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp start_date = 1;
     */
    startDate?: Timestamp;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp end_date = 2;
     */
    endDate?: Timestamp;
}
/**
 * buf:lint:ignore ENUM_VALUE_PREFIX
 *
 * @generated from protobuf enum billing.v1.PaymentMethodAttachmentStatus
 */
export enum PaymentMethodAttachmentStatus {
    /**
     * @generated from protobuf enum value: PAYMENT_METHOD_STATUS_UNSPECIFIED = 0;
     */
    PAYMENT_METHOD_STATUS_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: PAYMENT_METHOD_STATUS_ATTACHED = 1;
     */
    PAYMENT_METHOD_STATUS_ATTACHED = 1,
    /**
     * @generated from protobuf enum value: PAYMENT_METHOD_STATUS_ATTACHING = 2;
     */
    PAYMENT_METHOD_STATUS_ATTACHING = 2,
    /**
     * @generated from protobuf enum value: PAYMENT_METHOD_STATUS_UNATTACHED = 3;
     */
    PAYMENT_METHOD_STATUS_UNATTACHED = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class Address$Type extends MessageType<Address> {
    constructor() {
        super("billing.v1.Address", [
            { no: 1, name: "line1", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "line2", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "postal_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "country", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.Address
 */
export const Address = new Address$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinalizeAmountDueRequest$Type extends MessageType<FinalizeAmountDueRequest> {
    constructor() {
        super("billing.v1.FinalizeAmountDueRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "address", kind: "message", T: () => Address }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.FinalizeAmountDueRequest
 */
export const FinalizeAmountDueRequest = new FinalizeAmountDueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinalizeAmountDueResponse$Type extends MessageType<FinalizeAmountDueResponse> {
    constructor() {
        super("billing.v1.FinalizeAmountDueResponse", [
            { no: 1, name: "subtotal", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "tax", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "total", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.FinalizeAmountDueResponse
 */
export const FinalizeAmountDueResponse = new FinalizeAmountDueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateStripeSetupIntentRequest$Type extends MessageType<CreateStripeSetupIntentRequest> {
    constructor() {
        super("billing.v1.CreateStripeSetupIntentRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.CreateStripeSetupIntentRequest
 */
export const CreateStripeSetupIntentRequest = new CreateStripeSetupIntentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateStripeSetupIntentResponse$Type extends MessageType<CreateStripeSetupIntentResponse> {
    constructor() {
        super("billing.v1.CreateStripeSetupIntentResponse", [
            { no: 1, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.CreateStripeSetupIntentResponse
 */
export const CreateStripeSetupIntentResponse = new CreateStripeSetupIntentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateStripePaymentIntentRequest$Type extends MessageType<CreateStripePaymentIntentRequest> {
    constructor() {
        super("billing.v1.CreateStripePaymentIntentRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.CreateStripePaymentIntentRequest
 */
export const CreateStripePaymentIntentRequest = new CreateStripePaymentIntentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateStripePaymentIntentResponse$Type extends MessageType<CreateStripePaymentIntentResponse> {
    constructor() {
        super("billing.v1.CreateStripePaymentIntentResponse", [
            { no: 1, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.CreateStripePaymentIntentResponse
 */
export const CreateStripePaymentIntentResponse = new CreateStripePaymentIntentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveOrganizationBillingInfoRequest$Type extends MessageType<RemoveOrganizationBillingInfoRequest> {
    constructor() {
        super("billing.v1.RemoveOrganizationBillingInfoRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.RemoveOrganizationBillingInfoRequest
 */
export const RemoveOrganizationBillingInfoRequest = new RemoveOrganizationBillingInfoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveOrganizationBillingInfoResponse$Type extends MessageType<RemoveOrganizationBillingInfoResponse> {
    constructor() {
        super("billing.v1.RemoveOrganizationBillingInfoResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.RemoveOrganizationBillingInfoResponse
 */
export const RemoveOrganizationBillingInfoResponse = new RemoveOrganizationBillingInfoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReplaceFragmentRequest$Type extends MessageType<ReplaceFragmentRequest> {
    constructor() {
        super("billing.v1.ReplaceFragmentRequest", [
            { no: 1, name: "machine_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "fragment_to_delete", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "fragment_to_add", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.ReplaceFragmentRequest
 */
export const ReplaceFragmentRequest = new ReplaceFragmentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReplaceFragmentResponse$Type extends MessageType<ReplaceFragmentResponse> {
    constructor() {
        super("billing.v1.ReplaceFragmentResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.ReplaceFragmentResponse
 */
export const ReplaceFragmentResponse = new ReplaceFragmentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomBillingMetadataRequest$Type extends MessageType<GetCustomBillingMetadataRequest> {
    constructor() {
        super("billing.v1.GetCustomBillingMetadataRequest", [
            { no: 1, name: "namespace", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.GetCustomBillingMetadataRequest
 */
export const GetCustomBillingMetadataRequest = new GetCustomBillingMetadataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomBillingMetadataResponse$Type extends MessageType<GetCustomBillingMetadataResponse> {
    constructor() {
        super("billing.v1.GetCustomBillingMetadataResponse", [
            { no: 1, name: "metadata", kind: "message", T: () => CustomBillingMetadata }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.GetCustomBillingMetadataResponse
 */
export const GetCustomBillingMetadataResponse = new GetCustomBillingMetadataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MachineWithFragment$Type extends MessageType<MachineWithFragment> {
    constructor() {
        super("billing.v1.MachineWithFragment", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "location_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "billing_tier_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.MachineWithFragment
 */
export const MachineWithFragment = new MachineWithFragment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMachinesWithBillableFragmentsRequest$Type extends MessageType<GetMachinesWithBillableFragmentsRequest> {
    constructor() {
        super("billing.v1.GetMachinesWithBillableFragmentsRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "fragment_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.GetMachinesWithBillableFragmentsRequest
 */
export const GetMachinesWithBillableFragmentsRequest = new GetMachinesWithBillableFragmentsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMachinesWithBillableFragmentsResponse$Type extends MessageType<GetMachinesWithBillableFragmentsResponse> {
    constructor() {
        super("billing.v1.GetMachinesWithBillableFragmentsResponse", [
            { no: 1, name: "machines", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MachineWithFragment }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.GetMachinesWithBillableFragmentsResponse
 */
export const GetMachinesWithBillableFragmentsResponse = new GetMachinesWithBillableFragmentsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CustomBillingMetadata$Type extends MessageType<CustomBillingMetadata> {
    constructor() {
        super("billing.v1.CustomBillingMetadata", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "orgID", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "baseURL", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "logo", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "secondaryLogo", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "fragmentPlanIds", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.CustomBillingMetadata
 */
export const CustomBillingMetadata = new CustomBillingMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrgBillingInfoRequest$Type extends MessageType<GetOrgBillingInfoRequest> {
    constructor() {
        super("billing.v1.GetOrgBillingInfoRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.GetOrgBillingInfoRequest
 */
export const GetOrgBillingInfoRequest = new GetOrgBillingInfoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PaymentMethod$Type extends MessageType<PaymentMethod> {
    constructor() {
        super("billing.v1.PaymentMethod", [
            { no: 1, name: "type", kind: "enum", T: () => ["viam.app.v1.PaymentMethodType", PaymentMethodType, "PAYMENT_METHOD_TYPE_"] },
            { no: 2, name: "card", kind: "message", T: () => PaymentMethodCard },
            { no: 4, name: "method_attachment_status", kind: "enum", T: () => ["billing.v1.PaymentMethodAttachmentStatus", PaymentMethodAttachmentStatus] },
            { no: 5, name: "us_bank_account", kind: "message", T: () => PaymentMethodUSBankAccount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.PaymentMethod
 */
export const PaymentMethod = new PaymentMethod$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrgBillingInfoResponse$Type extends MessageType<GetOrgBillingInfoResponse> {
    constructor() {
        super("billing.v1.GetOrgBillingInfoResponse", [
            { no: 1, name: "billing_email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "billing_tier", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "method", kind: "message", T: () => PaymentMethod }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.GetOrgBillingInfoResponse
 */
export const GetOrgBillingInfoResponse = new GetOrgBillingInfoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetMonthlyBillingAlertThresholdRequest$Type extends MessageType<SetMonthlyBillingAlertThresholdRequest> {
    constructor() {
        super("billing.v1.SetMonthlyBillingAlertThresholdRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "threshold", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.SetMonthlyBillingAlertThresholdRequest
 */
export const SetMonthlyBillingAlertThresholdRequest = new SetMonthlyBillingAlertThresholdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetMonthlyBillingAlertThresholdResponse$Type extends MessageType<SetMonthlyBillingAlertThresholdResponse> {
    constructor() {
        super("billing.v1.SetMonthlyBillingAlertThresholdResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.SetMonthlyBillingAlertThresholdResponse
 */
export const SetMonthlyBillingAlertThresholdResponse = new SetMonthlyBillingAlertThresholdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteMonthlyBillingAlertThresholdRequest$Type extends MessageType<DeleteMonthlyBillingAlertThresholdRequest> {
    constructor() {
        super("billing.v1.DeleteMonthlyBillingAlertThresholdRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.DeleteMonthlyBillingAlertThresholdRequest
 */
export const DeleteMonthlyBillingAlertThresholdRequest = new DeleteMonthlyBillingAlertThresholdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteMonthlyBillingAlertThresholdResponse$Type extends MessageType<DeleteMonthlyBillingAlertThresholdResponse> {
    constructor() {
        super("billing.v1.DeleteMonthlyBillingAlertThresholdResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.DeleteMonthlyBillingAlertThresholdResponse
 */
export const DeleteMonthlyBillingAlertThresholdResponse = new DeleteMonthlyBillingAlertThresholdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMonthlyBillingAlertThresholdRequest$Type extends MessageType<GetMonthlyBillingAlertThresholdRequest> {
    constructor() {
        super("billing.v1.GetMonthlyBillingAlertThresholdRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.GetMonthlyBillingAlertThresholdRequest
 */
export const GetMonthlyBillingAlertThresholdRequest = new GetMonthlyBillingAlertThresholdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMonthlyBillingAlertThresholdResponse$Type extends MessageType<GetMonthlyBillingAlertThresholdResponse> {
    constructor() {
        super("billing.v1.GetMonthlyBillingAlertThresholdResponse", [
            { no: 1, name: "threshold", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "last_notified", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.GetMonthlyBillingAlertThresholdResponse
 */
export const GetMonthlyBillingAlertThresholdResponse = new GetMonthlyBillingAlertThresholdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRegistryItemServicePeriodRequest$Type extends MessageType<GetRegistryItemServicePeriodRequest> {
    constructor() {
        super("billing.v1.GetRegistryItemServicePeriodRequest", [
            { no: 1, name: "registry_item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "robot_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.GetRegistryItemServicePeriodRequest
 */
export const GetRegistryItemServicePeriodRequest = new GetRegistryItemServicePeriodRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRegistryItemServicePeriodResponse$Type extends MessageType<GetRegistryItemServicePeriodResponse> {
    constructor() {
        super("billing.v1.GetRegistryItemServicePeriodResponse", [
            { no: 1, name: "start_date", kind: "message", T: () => Timestamp },
            { no: 2, name: "end_date", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.GetRegistryItemServicePeriodResponse
 */
export const GetRegistryItemServicePeriodResponse = new GetRegistryItemServicePeriodResponse$Type();
/**
 * @generated ServiceType for protobuf service billing.v1.BillingService
 */
export const BillingService = new ServiceType("billing.v1.BillingService", [
    { name: "FinalizeAmountDue", options: {}, I: FinalizeAmountDueRequest, O: FinalizeAmountDueResponse },
    { name: "CreateStripeSetupIntent", options: {}, I: CreateStripeSetupIntentRequest, O: CreateStripeSetupIntentResponse },
    { name: "CreateStripePaymentIntent", options: {}, I: CreateStripePaymentIntentRequest, O: CreateStripePaymentIntentResponse },
    { name: "RemoveOrganizationBillingInfo", options: {}, I: RemoveOrganizationBillingInfoRequest, O: RemoveOrganizationBillingInfoResponse },
    { name: "ReplaceFragment", options: {}, I: ReplaceFragmentRequest, O: ReplaceFragmentResponse },
    { name: "GetCustomBillingMetadata", options: {}, I: GetCustomBillingMetadataRequest, O: GetCustomBillingMetadataResponse },
    { name: "GetMachinesWithBillableFragments", options: {}, I: GetMachinesWithBillableFragmentsRequest, O: GetMachinesWithBillableFragmentsResponse },
    { name: "GetOrgBillingInfo", options: {}, I: GetOrgBillingInfoRequest, O: GetOrgBillingInfoResponse },
    { name: "SetMonthlyBillingAlertThreshold", options: {}, I: SetMonthlyBillingAlertThresholdRequest, O: SetMonthlyBillingAlertThresholdResponse },
    { name: "DeleteMonthlyBillingAlertThreshold", options: {}, I: DeleteMonthlyBillingAlertThresholdRequest, O: DeleteMonthlyBillingAlertThresholdResponse },
    { name: "GetMonthlyBillingAlertThreshold", options: {}, I: GetMonthlyBillingAlertThresholdRequest, O: GetMonthlyBillingAlertThresholdResponse },
    { name: "GetRegistryItemServicePeriod", options: {}, I: GetRegistryItemServicePeriodRequest, O: GetRegistryItemServicePeriodResponse }
]);
